import React, { useState } from "react";

const cardStyle: React.CSSProperties = {
  background: "#ffffff",
  border: "1px solid #e5e7eb",
  borderRadius: 18,
  padding: "1rem",
};

const gridStyle: React.CSSProperties = {
  display: "grid",
  gap: "1rem",
  gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
};

const inputStyle: React.CSSProperties = {
  width: "100%",
  border: "1px solid #d1d5db",
  borderRadius: 12,
  padding: "0.85rem 0.95rem",
  fontSize: "0.98rem",
  background: "#fff",
};

const labelStyle: React.CSSProperties = {
  display: "grid",
  gap: "0.45rem",
  fontSize: "0.92rem",
  fontWeight: 600,
  color: "#334155",
};

const buttonStyle: React.CSSProperties = {
  border: "none",
  borderRadius: 12,
  background: "#111827",
  color: "#fff",
  padding: "0.85rem 1rem",
  fontWeight: 700,
  cursor: "pointer",
};

export default function ProviderCalendarPage() {
  const [savedAt, setSavedAt] = useState<string | null>(null);
  const [form, setForm] = useState({
    monday: "09:00 - 18:00",
    tuesday: "09:00 - 18:00",
    wednesday: "09:00 - 18:00",
    thursday: "09:00 - 18:00",
    friday: "09:00 - 19:00",
    saturday: "10:00 - 18:00",
    sunday: "Closed",
    slotInterval: "30",
    bufferTime: "10",
    blockedNotes: "",
  });

  const updateField =
    (field: keyof typeof form) =>
    (
      event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>,
    ) => {
      setForm((current) => ({ ...current, [field]: event.target.value }));
    };

  const handleSave = (event: React.FormEvent) => {
    event.preventDefault();
    setSavedAt(new Date().toLocaleTimeString());
  };

  return (
    <div style={{ display: "grid", gap: "1rem" }}>
      <section style={cardStyle}>
        <h2 style={{ margin: 0, color: "#0f172a" }}>Calendar</h2>
        <p style={{ margin: "0.5rem 0 0", color: "#475569", lineHeight: 1.7 }}>
          Define provider hours, slot interval, and blocked-time notes for operational readiness.
        </p>
      </section>

      <form onSubmit={handleSave} style={{ display: "grid", gap: "1rem" }}>
        <section style={cardStyle}>
          <h3 style={{ margin: 0, color: "#0f172a" }}>Weekly hours</h3>
          <div style={{ ...gridStyle, marginTop: "1rem" }}>
            {(
              [
                "monday",
                "tuesday",
                "wednesday",
                "thursday",
                "friday",
                "saturday",
                "sunday",
              ] as const
            ).map((day) => (
              <label key={day} style={labelStyle}>
                {day.charAt(0).toUpperCase() + day.slice(1)}
                <input
                  style={inputStyle}
                  value={form[day]}
                  onChange={updateField(day)}
                />
              </label>
            ))}
          </div>
        </section>

        <section style={cardStyle}>
          <h3 style={{ margin: 0, color: "#0f172a" }}>Slot rules</h3>
          <div style={{ ...gridStyle, marginTop: "1rem" }}>
            <label style={labelStyle}>
              Slot interval (minutes)
              <select
                style={inputStyle}
                value={form.slotInterval}
                onChange={updateField("slotInterval")}
              >
                <option value="15">15</option>
                <option value="20">20</option>
                <option value="30">30</option>
                <option value="45">45</option>
                <option value="60">60</option>
              </select>
            </label>

            <label style={labelStyle}>
              Buffer time (minutes)
              <select
                style={inputStyle}
                value={form.bufferTime}
                onChange={updateField("bufferTime")}
              >
                <option value="0">0</option>
                <option value="5">5</option>
                <option value="10">10</option>
                <option value="15">15</option>
              </select>
            </label>
          </div>
        </section>

        <section style={cardStyle}>
          <label style={labelStyle}>
            Blocked times or exceptions
            <textarea
              style={{ ...inputStyle, minHeight: 120, resize: "vertical" }}
              value={form.blockedNotes}
              onChange={updateField("blockedNotes")}
              placeholder="Example: Closed first Monday of each month, team training on Wednesdays 15:00-16:00."
            />
          </label>
        </section>

        <section style={cardStyle}>
          <div style={{ display: "flex", justifyContent: "space-between", gap: "1rem", flexWrap: "wrap" }}>
            <div style={{ color: "#475569" }}>
              {savedAt ? `Calendar saved locally at ${savedAt}` : "No local save yet"}
            </div>
            <button type="submit" style={buttonStyle}>
              Save calendar
            </button>
          </div>
        </section>
      </form>
    </div>
  );
}